import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

import imagen1 from "./images/imagen1.jpg";
import imagen2 from "./images/imagen2.jpg";
import imagen3 from "./images/imagen3.jpg";
import imagen4 from "./images/imagen4.jpg";
import imagen5 from "./images/imagen5.jpg";
import imagen6 from "./images/imagen6.jpg";
import imagen7 from "./images/imagen7.jpg";
import logo from "./images/logo.png";

const MainContent = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 992);
  const carouselImages = [
    { src: imagen1, alt: "Actividad institucional 1" },
    { src: imagen2, alt: "Actividad institucional 2" },
    { src: imagen3, alt: "Actividad institucional 3" },
    { src: imagen4, alt: "Actividad institucional 4" },
    { src: imagen5, alt: "Actividad institucional 5" },
    { src: imagen6, alt: "Actividad institucional 6" },
    { src: imagen7, alt: "Actividad institucional 7" }
  ];

  // Detectar el cambio de tamaño de la ventana
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 992);
    };

    window.addEventListener("resize", handleResize); // Escuchar el cambio de tamaño de la ventana
    return () => {
      window.removeEventListener("resize", handleResize); // Limpiar el listener cuando el componente se desmonte
    };
  }, []);
  return (
    
    <div
      style={{
        maxHeight: "100vh",  // Ajusta la altura máxima según el tamaño de la pantalla
        overflowY: "auto",  // Activa el scroll vertical
        padding: "10px"
      }}
      >
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top"
      style={{
        boxShadow: isLargeScreen ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none", // Solo en pantallas grandes
        padding: isLargeScreen ? "5px 300px" : "5px" // Solo en pantallas grandes
      }}
    >
    
        <a className="navbar-brand" href="#">
          <img src={logo} alt="Logo" width="30" height="24" />
          Instituto Silviano Carrillo
        </a>
        
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="nav nav-pills">
            <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="#bienvenidos">
                Hogar
              </a>

            </li>
            <li className="nav-item">
              <a className="nav-link" href="tel:+523414121453">
                Contactanos
              </a>
            </li>
            <li className="nav-item">
              <Link to="/login">
                <button className="btn btn-outline-primary me-3" type="button">
                  Acceso
                </button>
              </Link>
            </li>
          </ul>
          <div className="d-flex align-items-center">
            <a
              href="https://web.facebook.com/iscguzmanguzman/?locale=es_LA&_rdc=1&_rdr#"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-sm me-2"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.youtube.com/@iscguzmantv"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-danger btn-sm me-2"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://www.instagram.com/explore/locations/1218558238224880/instituto-silviano-carrillo-cd-guzman/recent/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-danger btn-sm me-2"
              aria-label="Instagram"
              style={{
                background: "linear-gradient(to right, #F58529, #D9008C, #8a3ab9)",
                color: "white",
                border: "none",
                padding: "8px 7px",
                fontSize: "7px",
                borderRadius: "5px",
                transition: "background 0.3s ease-in-out",
              }}
            >
              <i className="fab fa-instagram" style={{ fontSize: "15px" }}></i>
            </a>
          </div>
        </div>
    </nav>
      <h1 className="text-center mt-5" id="bienvenidos">Bienvenido al Instituto Silviano Carrillo</h1>
      <p className="text-center">
        Aquí encontrarás información sobre nuestra misión, visión, y los servicios que ofrecemos.
        A demás de poder iniciar sesión si ya eres parte de nuestro instituto.
      </p>
     

      {/* Carrusel Bootstrap */}
      <div
        id="institutoCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="4500"
        data-bs-pause="false"
        data-bs-touch="true"
        data-bs-wrap="true"
        style={{ maxWidth: "900px", margin: "20px auto" }}
      >
        <div className="carousel-indicators">
          {carouselImages.map((_, index) => (
            <button
              key={`indicador-${index}`}
              type="button"
              data-bs-target="#institutoCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>
        <div className="carousel-inner">
          {carouselImages.map(({ src, alt }, index) => (
            <div
              key={`slide-${index}`}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img src={src} className="d-block w-100" alt={alt} />
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#institutoCarousel"
          data-bs-slide="prev"
          style={{ background: "transparent", border: "none" }}
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
            style={{ filter: "none", backgroundImage: "none" }}
          ></span>
          <span className="visually-hidden">Anterior</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#institutoCarousel"
          data-bs-slide="next"
          style={{ background: "transparent", border: "none" }}
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
            style={{ filter: "none", backgroundImage: "none" }}
          ></span>
          <span className="visually-hidden">Siguiente</span>
        </button>
      </div>
      <p
        style={{
          fontFamily: "'Times New Roman', serif",
          fontWeight: "bold",
          fontSize: "36px",
          textAlign: "center",
        }}
      >
        ¡Fieles al deber!
      </p>
      <img
        src={logo}
        alt="Logo Instituto Silviano Carrillo"
        style={{ display: "block", margin: "0 auto", maxWidth: "200px" }}
      />

      {/* Misión y Visión */}
      <div className="container mt-5">
        <h3>MISIÓN</h3>
        <p>
          Anunciar el Reino de Dios y colaborar con los padres de familia en
          formación integral de los alumnos, a la luz del Evangelio, teniendo
          como centro a Jesús Sacramentado, a fin de lograr auténticos hijos de
          Dios y ciudadanos de la Patria. (II Crón. SJS).
        </p>

        <h3>VISIÓN</h3>
        <p>
          Somos una institución educativa innovadora, a la vanguardia en
          procesos formativos de calidad, donde se preparan personas competentes,
          capaces de enfrentar con éxito los retos del mundo actual, con dimensión
          trascendente.
        </p>

        <h3>1. CRITERIOS DE FORMACIÓN</h3>
        <p>
          El Instituto 'Silviano Carrillo' además de sujetarse a los programas
          oficiales, busca medios para promover Valores y proporcionar una sólida
          formación cristiana de acuerdo al ideal y Filosofía del Siervo de Dios
          Silviano Carrillo Cárdenas. Se imparten en todos los grados: Educación
          en la Fe, Educación Física, Computación, Inglés. Se ofrecen talleres de:
          Música, Danza, Robótica, Ajedrez, Banda de guerra. Cuenta con servicios
          de Dpto. de Psicología, Primeros auxilios, Seguro escolar, Biblioteca,
          Salón de actos, Sala de usos múltiples y Patios de juego.
        </p>

        <h3>2. ORGANIZACIÓN</h3>
        <p>
          El Instituto 'Silviano Carrillo' tiene al frente de cada sección una
          Coordinadora cuya función es colaborar con la dirección general en la
          planeación del Proyecto Educativo, realización de actividades escolares y
          evaluación del trabajo, así como atender a los aspectos disciplinarios y
          formación de los alumnos, integrando equipo en Consejo Técnico Escolar,
          con el personal docente y la comunidad educativa. Los padres de familia
          podrán tratar asuntos relativos a la educación de sus hijos con la
          Coordinadora respectiva conforme al horario que se informe.
        </p>

        <h3>3. PERSONAL</h3>
        <p>
          El Instituto “Silvano Carrillo” cuenta con personal preparado para
          ejercer las labores docentes y les proporciona capacitación y
          actualización. Se cuenta con la valiosa colaboración del Consejo
          Disciplinario y de Asuntos Jurídicos, Consejo de Asuntos Económicos y
          equipo responsable de Mejora Continua.
        </p>

        <h3>4. PADRES DE FAMILIA</h3>
        <p>
          Los Padres de Familia conscientes de que el Instituto es sólo
          colaborador en la educación de sus hijos, se comprometen a conocer,
          aceptar y apoyar los criterios y actividades de la Institución. Es deber
          supervisar el aprovechamiento de sus hijos, tanto en las materias del
          programa oficial como en las que el Instituto ofrece para la superación
          de los alumnos.
        </p>

        <h3>5. REGLAMENTO</h3>
        <p>
          Deben conocer, apoyar y dar cumplimiento al Reglamento de la
          Institución para asumir sus obligaciones y conocer sus derechos. A
          través de la Plataforma iscguzman.com podrán conocer más sobre la vida
          del Instituto y relación con los alumnos.
        </p>

        {/* Horarios de clases */}
        <h3>6. HORARIO DE CLASES</h3>
        <table>
          <thead>
            <tr>
              <th>SECCIÓN</th>
              <th>HORA DE ENTRADA</th>
              <th>HORA DE SALIDA</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Preescolar</td>
              <td>8:00 a.m.</td>
              <td>Lun a Vier 2:10 p.m. Juev y Vier 1:40 p.m.</td>
            </tr>
            <tr>
              <td>Primaria Menor</td>
              <td>7:20 a.m.</td>
              <td>2:30 p.m. Diariamente</td>
            </tr>
            <tr>
              <td>Primaria Mayor</td>
              <td>7:20 a.m.</td>
              <td>2:30 p.m. "</td>
            </tr>
            <tr>
              <td>Secundaria</td>
              <td>7:00 a.m.</td>
              <td>2:30 p.m. "</td>
            </tr>
            <tr>
              <td>Preparatoria</td>
              <td>7:00 a.m.</td>
              <td>3:00 p.m. "</td>
            </tr>
          </tbody>
        </table>

        {/* Inscripción y transporte */}
        <h3>7. INSCRIPCIÓN</h3>
        <p>
          Los padres deben hacer los trámites respectivos en forma personal dentro
          de las fechas y horarios que se indiquen.
        </p>
        <h3>8. TRANSPORTE ESCOLAR</h3>
        <p>
          El Instituto "Silviano Carrillo" <strong>NO</strong> ofrece este servicio,
          por lo tanto es ajeno a toda responsabilidad sobre el transporte escolar.
        </p>

        <h3>9. UNIFORME Y ÚTILES ESCOLARES</h3>
        <p>
          Los padres de Familia son libres de adquirir los uniformes y útiles
          escolares donde más les convenga, deben sujetarse a las indicaciones que
          al respecto indique el reglamento escolar.
        </p>

        <h3>10. INFORMACIÓN GENERAL</h3>
        <p>
          Cada mes se hará llegar el calendario de actividades de forma digital.
        </p>

        <h3>11. INFORMACIÓN ADICIONAL</h3>
        <p>
          Si desea más información (Colegiaturas, Cuotas de inscripción, Cuotas de
          Material, entre otras), vaya al instituto entre las 7:00 a.m. y las 2:30
          p.m. de Lunes a Viernes.
        </p>
      </div>

      {/* Mapa y Acordeón */}
      <div className="container mt-4">
        <div className="row">
          {/* Columna del mapa */}
          <div className="col-md-6 mb-3">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3391.5741377981244!2d-70.9671023!3d-31.7820992!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842f86bb66ab9765%3A0xd8a9d66aa8f46ad7!2sInstituto%20Silviano%20Carrillo!5e0!3m2!1ses-419!2smx!4v1747856003469!5m2!1ses-419!2smx"
              width="100%"
              height="400"
              style={{ border: "0" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa del Instituto Silviano Carrillo"
            ></iframe>
          </div>

          
          {/* Columna del acordeón */}
          <div className="col-md-6 mb-3">
            <h2
              style={{
                color: "white",
                backgroundColor: "#8FC1CC",
                textAlign: "center",
              }}
            >
              CLASES ESPECIALES
            </h2>
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingOne">
                  <button
                    style={{ backgroundColor: "#8FC1CC" }}
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    JARDÍN DE NIÑOS
                  </button>
                </h2>
                <div
                  id="flush-collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingOne"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <h4>Escuela Bilingüe</h4>
                    <ul>
                      <li>Educación en valores</li>
                      <li>Juegos recreativos</li>
                      <li>Educación en la Fe</li>
                      <li>Educación Física</li>
                      <li>Computación</li>
                      <li>Informática</li>
                      <li>Psicomotricidad fina y gruesa (Lecto escritura)</li>
                      <li>Ritmos, cantos y juegos</li>
                      <li>Tutorías</li>
                    </ul>
                  </div>
                </div>
              </div>

                {/* Add similar sections for other grades... */}

                <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTwo">
                    <button
                    style={{ backgroundColor: "#8FC1CC" }}
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                    >
                    PRIMARIA
                    </button>
                </h2>
                <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionFlushExample"
                >
                    <div className="accordion-body">
                    <h4>Escuela Bilingüe</h4>
                    <ul>
                        <li>Educación en la Fe</li>
                        <li>Educación Física</li>
                        <li>Computación</li>
                        <li>Proyecto de Informática</li>
                        <li>Educación en valores</li>
                        <li>Robótica</li>
                        <li>Talleres</li>
                        <li>Tutorías. Habilidades socio emocionales</li>
                    </ul>
                    </div>
                </div>
                </div>

                <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingThree">
                    <button
                    style={{ backgroundColor: "#8FC1CC" }}
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-collapseThree"
                    >
                    SECUNDARIA
                    </button>
                </h2>
                <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree"
                    data-bs-parent="#accordionFlushExample"
                >
                    <div className="accordion-body">
                    <h4>Escuela Bilingüe</h4>
                    <ul>
                        <li>Educación en la Fe</li>
                        <li>Educación Física</li>
                        <li>Computación</li>
                        <li>Proyecto de Informática</li>
                        <li>Educación en valores</li>
                        <li>Robótica</li>
                        <li>Talleres</li>
                        <li>Tutorías. Habilidades socio emocionales</li>
                    </ul>
                    </div>
                </div>
                </div>

                <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFour">
                    <button
                    style={{ backgroundColor: "#8FC1CC" }}
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFour"
                    aria-expanded="false"
                    aria-controls="flush-collapseFour"
                    >
                    PREPARATORIA
                    </button>
                </h2>
                <div
                    id="flush-collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingFour"
                    data-bs-parent="#accordionFlushExample"
                >
                    <div className="accordion-body">
                    <h4>Escuela Bilingüe</h4>
                    <ul>
                        <li>Educación en la Fe</li>
                        <li>Educación Física</li>
                        <li>Computación</li>
                        <li>Proyecto de Informática</li>
                        <li>Educación en valores</li>
                        <li>Robótica</li>
                        <li>Talleres</li>
                        <li>Tutorías. Habilidades socio emocionales</li>
                    </ul>
                    </div>
                </div>
                </div>

            </div>
          </div>
        </div>
      </div>

      <footer className="bg-light text-center text-lg-start mt-5 py-3 border-top">
      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div>
          &copy; 2025 Instituto Silviano Carrillo. Todos los derechos reservados.
        </div>
        <div>
          <a
            href="https://wa.me/523414121453"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success"
            style={{ color: "white" }}
          >
            Contactanos por WhatsApp
          </a>
        </div>
      </div>
    </footer>
      

    </div>
    
  );
};

export default MainContent;
